var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PALMSController = {
    /*****************************************************************************************************
        * Is using route "api/PALMS/trainingRecord" and http method "POST" to call the back-end.
    
        * @returns {any}
    ******************************************************************************************************/
    TrainingRecord: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/trainingRecord", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/learningInfo/{ppnId?}" and http method "GET" to call the back-end.
    
        * @param {string} ppnId
        * @returns {PALMSUserData}
    ******************************************************************************************************/
    LearningInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/learningInfo/{ppnId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/learningPaths" and http method "POST" to call the back-end.
    
        * @param {string} dateString
        * @param {string} ppnId
        * @param {boolean} onlyPalms
        * @returns {PALMSUserData}
    ******************************************************************************************************/
    LearningPaths: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dateString", JSON.stringify(data.dateString));
        fd.append("ppnId", JSON.stringify(data.ppnId));
        fd.append("onlyPalms", JSON.stringify(data.onlyPalms));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/learningPaths", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/learningPaths/playlist" and http method "POST" to call the back-end.
    
        * @param {string} dateString
        * @returns {PALMSUserData}
    ******************************************************************************************************/
    LearningPathsPlaylists: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dateString", JSON.stringify(data.dateString));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/learningPaths/playlist", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/learningPath/" and http method "POST" to call the back-end.
    
        * @param {string} dateString
        * @param {string} learningId
        * @param {string} ppnId
        * @returns {PALMSUserData}
    ******************************************************************************************************/
    LearningPath: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dateString", JSON.stringify(data.dateString));
        fd.append("learningId", JSON.stringify(data.learningId));
        fd.append("ppnId", JSON.stringify(data.ppnId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/learningPath/", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/modules/{ppnId?}" and http method "POST" to call the back-end.
    
        * @param {string} keywords
        * @param {string} ppnId
        * @returns {SearchResultsDto<PALMSModule>}
    ******************************************************************************************************/
    Modules: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("keywords", JSON.stringify(data.keywords));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/modules/{ppnId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/modules/{catalogName?}" and http method "GET" to call the back-end.
    
        * @param {string} catalogName
        * @returns {SearchResultsDto<PALMSModule>}
    ******************************************************************************************************/
    CatalogSearch: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/modules/{catalogName?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/modules/start/link" and http method "POST" to call the back-end.
    
        * @param {string[]} moduleIds
        * @param {string} playlistId
        * @returns {Record<string, string>}
    ******************************************************************************************************/
    GetLinks: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("moduleIds", JSON.stringify(data.moduleIds));
        fd.append("playlistId", JSON.stringify(data.playlistId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/modules/start/link", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/status/learner" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {StatusInfo}
    ******************************************************************************************************/
    StatusInfoLearner: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/status/learner", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/status/manager" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {StatusInfo}
    ******************************************************************************************************/
    StatusInfoManager: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/status/manager", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/glp" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {GLPEntry[]}
    ******************************************************************************************************/
    GLP: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/glp", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/glp/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {GLPEntry[]}
    ******************************************************************************************************/
    GLPSelf: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/glp/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    TMD: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    TMDDetails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/tmd/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TMDEntry[]}
    ******************************************************************************************************/
    TMDSelf: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/tmd/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    ZPT: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    ZPTDetails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/ZPT/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    ZPTself: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/ZPT/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    PGCS: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PGCSself: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/PGCS/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    PGCSDetails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/PGCS/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/HVT" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationEntry[]}
    ******************************************************************************************************/
    HVT: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/HVT", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/HVT/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {LevelCertificationUserEntry[]}
    ******************************************************************************************************/
    HVTDetails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/HVT/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/futureTrainings" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TrainingModule[]}
    ******************************************************************************************************/
    FutureTrainings: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/futureTrainings", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/futureTrainingsSelf" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {TrainingModule[]}
    ******************************************************************************************************/
    FutureTrainingsSelf: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/futureTrainingsSelf", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/MLR" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {ReadynessState[]}
    ******************************************************************************************************/
    MLR: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/MLR", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/MLR/details" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {MLREntry[]}
    ******************************************************************************************************/
    MLRdetails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/MLR/details", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/certification" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {CertificationEntry[]}
    ******************************************************************************************************/
    Certification: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/certification", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/certification/self" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {CertificationEntry[]}
    ******************************************************************************************************/
    CertificationSelf: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/certification/self", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/teamJobRoles/{teamManagerId}" and http method "GET" to call the back-end.
    
        * @param {string} teamManagerId
        * @returns {string[]}
    ******************************************************************************************************/
    TeamJobRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/teamJobRoles/{teamManagerId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/teamMembers" and http method "POST" to call the back-end.
    
        * @param {PALMSFilter} filter
        * @returns {PALMSUser[]}
    ******************************************************************************************************/
    TeamMembers: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/teamMembers", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/markets" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    Markets: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/markets", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/jobroles/{onlyManager}/{market?}" and http method "GET" to call the back-end.
    
        * @param {boolean} onlyManager
        * @param {string} market
        * @returns {string[]}
    ******************************************************************************************************/
    JobRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/jobroles/{onlyManager}/{market?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/PALMS/users/{onlyManager}/{jobrole?}" and http method "GET" to call the back-end.
    
        * @param {boolean} onlyManager
        * @param {string} jobrole
        * @returns {PALMSUser[]}
    ******************************************************************************************************/
    Users: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/PALMS/users/{onlyManager}/{jobrole?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PALMSController.js.map